import React from 'react'
import { Header } from '../Header'
import Icon from '../../utils/icons.js'
import I18n from '../../localization'
import { useMobileStyles } from "./styles.js"
import { APP_SOURCE } from '../../utils/constant.js'
import { isWeb } from '../../utils/utility.js'

function ErrorCard(props) {
  const { onGoBack, fetchAirDeviceById, source } = props
  const classes = useMobileStyles()
  return (
    <>
      {(source === APP_SOURCE.ENHO && !isWeb()) && <Header onClick={onGoBack} />}
      <div className={classes.hvDashboardErrorContainer}>
        <div></div>
        <div className={classes.descContainer}>
          <Icon src="serverError" />
          <div className={classes.errorDesc}>{I18n.t('mobile.common.errorMsg')}</div>
        </div>
        {source === APP_SOURCE.ENHO ? <div className={classes.tryAgainBtn} onClick={fetchAirDeviceById}>{I18n.t('mobile.common.tryAgain')}</div> : <div></div>}
      </div>
    </>
  )
}

export default ErrorCard
